export const SHORTCUT_KEYS_TAB_LIST = [
  { key: "view", label: "View" },
  { key: "layer", label: "Layer" },
  { key: "stage", label: "Stage" },
  { key: "tooth", label: "Tooth" },
];

export const SHORTCUTS_KEY_VIEW_DATA = {
  view: [
    { action: "Front", win: [["Alt", "1"]], mac: [["Opt", "1"]] },
    { action: "Back", win: [["Alt", "2"]], mac: [["Opt", "2"]] },
    { action: "Right", win: [["Alt", "3"]], mac: [["Opt", "3"]] },
    { action: "Left", win: [["Alt", "4"]], mac: [["Opt", "4"]] },
    { action: "Upper", win: [["Alt", "Q"]], mac: [["Opt", "Q"]] },
    { action: "Lower", win: [["Alt", "E"]], mac: [["Opt", "E"]] },
    // { action: "Center tooth", win: [["Alt", "C"]], mac: [["Opt", "C"]] },
  ],
  layer: [
    {
      action: "Show/Hide\nupper arch",
      win: [["Alt", "Shift", "Q"]],
      mac: [["Opt", "Shift", "Q"]],
    },
    {
      action: "Show/Hide\nlower arch",
      win: [["Alt", "Shift", "E"]],
      mac: [["Opt", "Shift", "E"]],
    },
    { action: "Show/Hide grid", win: [["Alt", "G"]], mac: [["Opt", "G"]] },
    { action: "Show/Hide IPR", win: [["Alt", "P"]], mac: [["Opt", "P"]] },
    { action: "Show/Hide\ncollisions", win: [["Alt", "I"]], mac: [["Opt", "I"]] },
    {
      action: "Show/Hide\nsuperimposition",
      win: [["Alt", "O"]],
      mac: [["Opt", "O"]],
    },
    {
      action: "Show/Hide gum",
      win: [["Alt", "M"]],
      mac: [["Opt", "M"]],
    },
  ],
  stage: [
    { action: "Play / pause", win: [["Space"]], mac: [["Space"]] },
    {
      action: "Initial stage",
      win: [["Shift", "ArrowLeft"]],
      mac: [["Shift", "ArrowLeft"]],
    },
    {
      action: "Final stage",
      win: [["Shift", "ArrowRight"]],
      mac: [["Shift", "ArrowRight"]],
    },
    { action: "Previous stage", win: [["ArrowLeft"]], mac: [["ArrowLeft"]] },
    { action: "Next stage", win: [["ArrowRight"]], mac: [["ArrowRight"]] },
  ],
  tooth: [
    { action: "Next tooth", win: [["Tab"]], mac: [["Tab"]] },
    {
      action: "Previous tooth",
      win: [["Win", "Ctrl", "Tab"]],
      mac: [["Opt", "Ctrl", "Tab"]],
    },
    { action: "Switch arch", win: [["Shift", "Tab"]], mac: [["Shift", "Tab"]] },
  ],
};

